const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, */*',
  pragma: 'no-cache',
  'cache-control': 'no-cache',
  Application: 'portal',
  Env: 'dev',
  'Client-Version': '0.1',
  Channel: 'web',
  Locale: 'it'
};

export default defaultHeaders;
